(function () {
  "use strict";

  const ROOT_SELECTOR = "[data-kit-set-control]";

  function bindVoiceMarqueeVisibility(section, rail) {
    if (section.__kitSetVoiceObserver) {
      section.__kitSetVoiceObserver.disconnect();
      section.__kitSetVoiceObserver = null;
    }

    // 默认暂停，进入视口后再跑，避免屏外持续合成
    rail.classList.add("is-paused");

    if (typeof IntersectionObserver === "undefined") {
      rail.classList.remove("is-paused");
      return;
    }

    var track = section.querySelector("[data-voice-track]") || rail;
    section.__kitSetVoiceObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          rail.classList.toggle("is-paused", !entry.isIntersecting);
        });
      },
      { root: null, threshold: 0.2 }
    );
    section.__kitSetVoiceObserver.observe(track);
  }

  function initVoiceMarquee(section) {
    var rail = section.querySelector("[data-voice-rail]");
    if (!rail) return;

    if (rail.dataset.cloned !== "true") {
      var group = rail.querySelector(".kit-set-control__voice-group");
      if (!group) return;

      var clone = group.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      rail.appendChild(clone);
      rail.dataset.cloned = "true";
    }

    bindVoiceMarqueeVisibility(section, rail);
  }

  function initProgramming(section) {
    var progContainer = section.querySelector("[data-prog-container]");
    if (!progContainer || progContainer.__kitSetProgReady) return;

    var slides = Array.from(progContainer.querySelectorAll("[data-prog-slide]"));
    var prevBtn = progContainer.querySelector("[data-prog-prev]");
    var nextBtn = progContainer.querySelector("[data-prog-next]");
    var slider = progContainer.querySelector("[data-prog-slider]");
    var currentIndex = 0;
    var total = slides.length;

    if (total === 0) return;

    progContainer.__kitSetProgReady = true;

    function syncButtons() {
      var atStart = currentIndex <= 0;
      var atEnd = currentIndex >= total - 1;

      if (prevBtn) {
        prevBtn.classList.toggle("is-disabled", atStart);
        prevBtn.disabled = atStart;
        prevBtn.setAttribute("aria-disabled", atStart ? "true" : "false");
      }

      if (nextBtn) {
        nextBtn.classList.toggle("is-disabled", atEnd);
        nextBtn.disabled = atEnd;
        nextBtn.setAttribute("aria-disabled", atEnd ? "true" : "false");
      }
    }

    function goToSlide(index) {
      if (index < 0 || index >= total || index === currentIndex) return;

      currentIndex = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle("is-active", i === currentIndex);
      });
      syncButtons();
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        goToSlide(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        goToSlide(currentIndex + 1);
      });
    }

    if (slider) {
      var startX = 0;
      var isSwiping = false;

      slider.addEventListener(
        "touchstart",
        function (e) {
          startX = e.touches[0].clientX;
          isSwiping = true;
        },
        { passive: true }
      );

      slider.addEventListener(
        "touchmove",
        function (e) {
          if (!isSwiping) return;
          var diff = startX - e.touches[0].clientX;
          if (Math.abs(diff) > 50) {
            goToSlide(currentIndex + (diff > 0 ? 1 : -1));
            isSwiping = false;
          }
        },
        { passive: true }
      );

      slider.addEventListener("touchend", function () {
        isSwiping = false;
      });
    }

    syncButtons();
  }

  function initSection(section) {
    if (!section) return;
    initVoiceMarquee(section);
    initProgramming(section);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section =
      event.target.querySelector(ROOT_SELECTOR) || event.target.closest(ROOT_SELECTOR);
    if (section) {
      if (section.__kitSetVoiceObserver) {
        section.__kitSetVoiceObserver.disconnect();
        section.__kitSetVoiceObserver = null;
      }
      section.querySelectorAll("[data-voice-rail]").forEach(function (rail) {
        rail.dataset.cloned = "";
        rail.classList.remove("is-paused");
      });
      var prog = section.querySelector("[data-prog-container]");
      if (prog) prog.__kitSetProgReady = false;
      initSection(section);
    }
  });
})();
